import React, { useState } from 'react'
import BasicCard from '../../../../../components/card/basiccard/BasicCard';
import { CardElement, CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';
import HorizontalSeparator from '../../../../../components/separator/horizontalSeparator/HorizontalSeparator';
import { componentKey as addFundsKey, setAddCardDetails, setIsStripeAddressFormValid, setOpenPrepayFundAccessConfirmationModal, setPaymentMethodDetails, setStripeAddressDetails, setStripeSalexTaxCalculationSuccessfull } from '../AddFundsSlice';
import Button from '../../../../../components/button/Button';
import { useDispatch, useSelector } from 'react-redux';
import styles from "../AddFunds.styles"
import { setLoadingState } from '../../PaymentDrawerSlice';
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import { MINIMUM_PREPAY_THRESHOLD, PAYMENT_DRAWER_LOADING_STATES, PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../constants';
import { addPrepayBalance } from '../AddFundsSaga';
import { componentKey as paymentDrawerKey } from '../../PaymentDrawerSlice';
import TextInput from '../../../../../components/input/textinput/TextInput';
import General from '../../../../../../libs/utility/General';
import { componentKey as authenticationComponentKey } from '../../../../authentication/AuthenticationSlice';
import PaymentGatewayCardFields from '../../../../../components/paymentgatewaycardfields/PaymentGatewayCardFields';


export const PayByCard = ({ placeOfOriginforpayment = PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE, onPayNowCb = () => { } }) => {

    const dispatch = useDispatch();

    const stripe = useStripe();
    const elements = useElements();

    const {  enteredAmount, addCardDetails, loadingState } = useSelector(state => state[addFundsKey]);
    const { billingDetails, disableEnterAmountField, estimatedTaxCalculationComplete, isCardPayment, savedAddress, paymentAddressDetails } = useSelector(state => state[paymentDrawerKey]);
	const { signedInUser } = useSelector((state) => state[authenticationComponentKey])

    const { FilingFee = 0, TINMatchFee = 0, StateFee = 0, USPSFee = 0, eDeliveryFee = 0 } = billingDetails;

    const [saveCardDetails, setSaveCardDetails] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [nameOnCard, setNameOnCard] = useState('')


    const addPrepayBalanceHandler = async (event) => {
        event.preventDefault();

        try {
            if (!Number(enteredAmount) || Number(enteredAmount) < MINIMUM_PREPAY_THRESHOLD ) {
                dispatch(addNotifications({ heading: "Error", message: `Please enter an amount more than $${MINIMUM_PREPAY_THRESHOLD}` }));
                return;
            }

            if (isProcessing) {
                return;
            }
            
            const addressDetails = General.transformToPaymentAddress(paymentAddressDetails) 
            addressDetails.address.country = addressDetails.address.country.replace('USA', 'US') 
            
            const stripeAddress = JSON.parse(JSON.stringify(addressDetails))
            delete stripeAddress.address.email
            
            dispatch(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.PAYMENT_BY_NEW_CARD_LOADING }))
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    address: stripeAddress.address,
                    email: "",
                    name: nameOnCard,
                    phone: "",
                }
            });
            

            setIsProcessing(true);


            if (!error) {
                const { id } = paymentMethod;
                //send id to the BE

                if (isCardPayment) {
                    // call API to deduct the amount from card
                    onPayNowCb({
                        card_id: id,
                        amount: enteredAmount,
                        placeOfOriginforpayment,
                        saveCardDetails,
                        addressDetails: addressDetails,
                        CardNumber: paymentMethod?.card?.last4 || "",
                        CommonCreditCardNumber: paymentMethod?.card?.last4 || "",
                    });
                } else {
                    if(signedInUser.UserType == 3){
                        dispatch(setPaymentMethodDetails(paymentMethod))
                        dispatch(setOpenPrepayFundAccessConfirmationModal(true))
                    }else{
                        dispatch(addPrepayBalance({ card_id: id, amount: enteredAmount, placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE, saveCardDetails, CardNumber: paymentMethod?.card?.last4 || "", CommonCreditCardNumber: paymentMethod?.card?.last4 || "", }))
                    }
                }
            } else {
                dispatch(addNotifications({ heading: "Error with payment method", message: error?.message }))
            }
        } catch (error) {
            console.log(error);
            dispatch(addNotifications({ heading: "Error", message: error }))
        } finally {
            setIsProcessing(false);
            dispatch(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.PAYMENT_BY_NEW_CARD_READY }))
        }

    };

    return (
        <>
            <BasicCard customStyles={{ display: "block", marginTop: "40px" }}>
                <PaymentGatewayCardFields handleCardDetailsChangeCb={(event) => dispatch(setAddCardDetails(event.complete))} />
                <HorizontalSeparator style={{ margin: "20px 0px" }} />
                <TextInput
                    name='name'
                    label={'Name on card'}
                    placeHolder='Name'
                    type='text'
                    value={nameOnCard}
                    onChangeCb={(e) => setNameOnCard(e.target.value)}
                />

                <div style={styles.cardFormBtnContainer}>
                    <Button onClickCb={(e) => {
                        if ((estimatedTaxCalculationComplete || !isCardPayment) || !disableEnterAmountField) {
                            addPrepayBalanceHandler(e);
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please calculate sales tax for entered card details" }));
                        }
                    }} disabled={!((estimatedTaxCalculationComplete || !isCardPayment) && nameOnCard !== "" && addCardDetails) || isProcessing} style={styles.cardFormBtn}>Pay Now</Button>
                </div>

            </BasicCard>
        </>
    )
}
